import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  ControlLabel,
  Button,
  Modal,
  FormGroup,
  Alert
} from "react-bootstrap";
import JqxGrid, { jqx } from "jqwidgets-scripts/jqwidgets-react-tsx/jqxgrid";
import "jqwidgets-scripts/jqwidgets/styles/jqx.bootstrap.css";
import "./CSS/Inventario.css";
import moment from "moment";
import Swal from "sweetalert2";
import Loading from "../../../views/Loading";
import { dominio } from "../../../routes_backend/routes.jsx";

const gridRef = React.createRef();
const gridUbicacionRef = React.createRef();
const barcodeRef = React.createRef();
const barcodeUbicacionRef = React.createRef();

const fechaDocumentoRef = React.createRef();
const commentsRef = React.createRef();
const codigoManualRef = React.createRef();
const itemCodeUbicacionSearchRef = React.createRef();
const ubicacionEstanteRef = React.createRef();
const ubicacionSeccionRef = React.createRef();
const ubicacionNivelRef = React.createRef();
const itemCodeCreateTagRef = React.createRef();
const dscriptionCreateTagRef = React.createRef();

const ESTANTES = [
  "0",
  "1",
  "2",
  "3",
  "19",
  "21",
  "22",
  "25",
  "26",
  "27",
  "28",
  "30",
  "31",
  "33",
  "34",
  "37",
  "38",
  "39",
  "41",
  "44",
  "45",
  "ACEITES",
  "GRADAS",
  "IT",
  "MEZZANINE",
  "PERFILES",
  "SEGUNDA",
  "TARIMAS",
  "TORNILLERIA",
  "TRANSITO",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z"
];

const SECCIONES = ["", "1", "2", "3", "4", "6", "A", "B", "C", "D", "E", "F", "G", "H"];

function xOrEmpty(v) {
  return v || "";
}

class Inventario extends Component {
  constructor(props) {
    super(props);

    this.isSwalOpen = false;

    this.state = {
      isLoading: false,
      data: [],
      dataMap: {},
      isMobile: window.innerWidth <= 768,
      finalizado: false,

      showListaModal: false,
      showUbicacionModal: false,
      showCreateTagModal: false,

      IdDocInventario: "",
      FechaDocumento: moment().format("YYYY-MM-DD"),
      FechaCreacion: "",
      FechaActualizacion: "",
      Usuario: "",
      currentUserId: "",
      Estado: "BORRADOR",
      Comments: "",

      ubicacionEstante: "",
      ubicacionSeccion: "",
      ubicacionNivel: "",
      ubicacionData: [],
      ubicacionDataMap: {},
      barcodeUbicacion: "",
      itemCodeUbicacionSearch: "",
      resultadosCodigoUbicacion: [],

      codigoManual: "",
      resultadosCodigo: [],

      barcodeInput: "",

      existingTagsMap: {},
      availableItems: [],
      isItemsLoading: false,

      inventariosGuardados: [],
      inventarioActual: null,
      listaFiltroTexto: "",
      listaFiltroFechaDesde: "",
      listaFiltroFechaHasta: "",

      autoSaveCounter: 0,
      isSyncing: false,
      backupKey: "inventario_autosave",

      mobileEditableInput: null,

      stockSAPMap: {},

      createTagContext: "inventario",
      createTagError: "",
      createTagForm: {
        ItemCode: "",
        Dscription: "",
        Estante: "",
        Seccion: "",
        Nivel: "",
        UserId: ""
      }
    };
  }

  componentDidMount() {
    window.addEventListener("resize", this.handleResize);

    if (!this.state.isMobile && barcodeRef.current) {
      barcodeRef.current.focus();
    }

    this.loadExistingTagsMap();
    this.loadUsuarioFromToken();
    this.loadAvailableItems();
    this.cargarInventariosGuardados();
    this.loadLocalBackup();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.data !== this.state.data && this.state.data.length > 0) {
      const missingCodes = this.state.data
        .filter((item) => !item.stockSAP && item.Codigo && !(item.Codigo in this.state.stockSAPMap))
        .map((item) => item.Codigo);
      if (missingCodes.length > 0) {
        console.log("[SAP] componentDidUpdate detectó items sin stock:", missingCodes);
        this.fetchStockForItems(missingCodes);
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize = () => {
    const isMobile = window.innerWidth <= 768;
    this.setState({ isMobile });

    if (!isMobile && barcodeRef.current) {
      setTimeout(() => {
        if (barcodeRef.current) barcodeRef.current.focus();
      }, 100);
    }
  };

  normalize = (v) => String(v ?? "").trim().toUpperCase();

  buildLocationDescTag = (estante, seccion, nivel) => {
    const e = String(estante ?? "").trim();
    const s = String(seccion ?? "").trim();
    const n = String(nivel ?? "").trim();
    return [e, s, n].join(" - ");
  };

  getNumericUserId = () => {
    const n = Number(this.state.currentUserId);
    return Number.isFinite(n) ? n : null;
  };

  loadAvailableItems = async () => {
    this.setState({ isItemsLoading: true });
    try {
      const res = await fetch(`${dominio}/getArticulosTags`);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const items = await res.json();
      this.setState({ availableItems: Array.isArray(items) ? items : [], isItemsLoading: false });
    } catch (err) {
      console.error("No se pudieron cargar items:", err);
      this.setState({ availableItems: [], isItemsLoading: false });
    }
  };

  loadExistingTagsMap = async () => {
    try {
      const respuesta = await fetch(`${dominio}/getTags`);
      if (!respuesta.ok) throw new Error(`HTTP ${respuesta.status}`);
      const data = await respuesta.json();

      const map = {};
      (Array.isArray(data) ? data : []).forEach((t) => {
        const tag = String(t?.number_tag || "").trim().toUpperCase();
        if (tag) map[tag] = t;
      });

      this.setState({ existingTagsMap: map });
      return map;
    } catch (err) {
      console.error("No se pudo cargar mapa de tags:", err);
      this.setState({ existingTagsMap: {} });
      return {};
    }
  };

  isInputEditable = (inputName) => {
    return !this.state.isMobile || this.state.mobileEditableInput === inputName;
  };

  enableMobileKeyboard = (inputName, ref) => {
    if (!this.state.isMobile) {
      if (ref?.current) ref.current.focus();
      return;
    }

    this.setState({ mobileEditableInput: inputName }, () => {
      if (ref && ref.current) {
        ref.current.focus();
        const val = ref.current.value || "";
        try {
          ref.current.setSelectionRange(val.length, val.length);
        } catch (e) {}
      }
    });
  };

  disableMobileKeyboard = () => {
    if (!this.state.isMobile) return;
    this.setState({ mobileEditableInput: null });
  };

  focusScanInputWithoutKeyboard = (ref) => {
    if (!ref?.current) return;
    try {
      ref.current.focus();
    } catch (e) {}
  };

  renderKeyboardButton = (inputName, ref, disabled = false) => {
    if (!this.state.isMobile || disabled) return null;

    return (
      <button
        type="button"
        onClick={() => this.enableMobileKeyboard(inputName, ref)}
        style={{
          width: "42px",
          minWidth: "42px",
          height: "42px",
          border: "1px solid #ccc",
          borderRadius: "6px",
          background: "#fff",
          marginLeft: "6px",
          fontSize: "18px",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
        title="Mostrar teclado"
      >
        ⌨️
      </button>
    );
  };

  renderInputContainer = (children) => (
    <div style={{ display: "flex", alignItems: "center", width: "100%" }}>{children}</div>
  );

  loadUsuarioFromToken = () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) return;

      const tokenData = JSON.parse(token);

      if (Array.isArray(tokenData) && tokenData.length > 0) {
        const usuario = tokenData[0].usuarioSAP || "";
        const userId = tokenData[0].U_UserId || "";
        this.setState({
          Usuario: usuario,
          currentUserId: String(userId),
          createTagForm: {
            ...this.state.createTagForm,
            UserId: String(userId)
          }
        });
      }
    } catch (error) {
      console.error("Error cargando usuario desde token:", error);
    }
  };

  // =========================
  // MODAL CREAR TAG
  // =========================
  openCreateTagModal = (itemCode = "", context = "inventario") => {
    const code = this.normalize(itemCode);
    const match = (this.state.availableItems || []).find((x) => this.normalize(x.ItemCode) === code);

    this.setState({
      showCreateTagModal: true,
      createTagContext: context,
      createTagError: "",
      createTagForm: {
        ItemCode: code,
        Dscription: match ? xOrEmpty(match.ItemName) : "",
        Estante: "",
        Seccion: "",
        Nivel: "",
        UserId: this.state.currentUserId || ""
      }
    });
  };

  closeCreateTagModal = () => {
    if (this.state.isLoading) return;
    this.setState({
      showCreateTagModal: false,
      createTagError: "",
      createTagForm: {
        ItemCode: "",
        Dscription: "",
        Estante: "",
        Seccion: "",
        Nivel: "",
        UserId: this.state.currentUserId || ""
      }
    });
  };

  onCreateTagFormChange = (field, value) => {
    this.setState((prev) => ({
      createTagForm: {
        ...prev.createTagForm,
        [field]: value
      }
    }));
  };

  onCreateTagItemCodeChange = (value) => {
    const code = this.normalize(value);
    const match = (this.state.availableItems || []).find((x) => this.normalize(x.ItemCode) === code);
    this.setState((prev) => ({
      createTagForm: {
        ...prev.createTagForm,
        ItemCode: code,
        Dscription: match ? xOrEmpty(match.ItemName) : prev.createTagForm.Dscription
      }
    }));
  };

  createTagFromModal = async () => {
    const { createTagForm, createTagContext } = this.state;

    const itemCode = this.normalize(createTagForm.ItemCode);
    const desc = String(createTagForm.Dscription || "").trim();
    const estante = String(createTagForm.Estante || "").trim() || null;
    const seccion = String(createTagForm.Seccion || "").trim() || null;
    const nivelRaw = String(createTagForm.Nivel || "").trim();
    const nivel = nivelRaw === "" ? null : nivelRaw;
    const userId = this.getNumericUserId();

    if (!itemCode || !desc) {
      this.setState({ createTagError: "ItemCode y Descripción son obligatorios." });
      return;
    }

    if (nivel !== null && !/^[0-9]+$/.test(String(nivel))) {
      this.setState({ createTagError: "Nivel debe ser numérico." });
      return;
    }

    if (userId === null) {
      this.setState({ createTagError: "No se pudo obtener un UserId válido desde el token." });
      return;
    }

    const payload = {
      ItemCode: itemCode,
      Dscription: desc,
      Estante: estante,
      Seccion: seccion,
      Nivel: nivel,
      UserId: userId,
      location_desc_tag: this.buildLocationDescTag(estante, seccion, nivel)
    };

    this.setState({ isLoading: true, createTagError: "" });

    try {
      const res = await fetch(`${dominio}/postTags`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });

      const body = await res.json().catch(() => ({}));
      if (!res.ok) {
        throw new Error(body?.error || body?.detail || `HTTP ${res.status}`);
      }

      await this.loadExistingTagsMap();

      const createdTag =
        body?.data?.data?.number_tag ||
        body?.data?.number_tag ||
        body?.number_tag ||
        null;

      if (!createdTag) {
        throw new Error("El backend no devolvió number_tag para el tag creado.");
      }

      this.closeCreateTagModal();

      if (createTagContext === "ubicacion") {
        await this.addOrIncrementUbicacionItem(String(createdTag).trim().toUpperCase(), 1);
        this.setState({
          itemCodeUbicacionSearch: "",
          resultadosCodigoUbicacion: []
        });
      } else {
        await this.addOrIncrementItem(String(createdTag).trim().toUpperCase(), 1);
        this.setState({ codigoManual: "", resultadosCodigo: [] });
      }

      Swal.fire("Éxito", "Tag creado y agregado al conteo correctamente.", "success");
    } catch (error) {
      console.error(error);
      this.setState({ createTagError: error?.message || "No se pudo crear el tag." });
    } finally {
      this.setState({ isLoading: false });
    }
  };

  // =========================
  // UBICACION
  // =========================
  buscarPorUbicacion = () => {
    const { ubicacionEstante, ubicacionSeccion, ubicacionNivel, existingTagsMap } = this.state;
    const estanteInput = String(ubicacionEstante ?? "").trim().toUpperCase();
    const seccionInput = String(ubicacionSeccion ?? "").trim().toUpperCase();
    const nivelInput = String(ubicacionNivel ?? "").trim().toUpperCase();

    const resultado = Object.values(existingTagsMap).filter((t) => {
      const estanteDB = String(t.Estante ?? "").trim().toUpperCase();
      const seccionDB = String(t.Seccion ?? "").trim().toUpperCase();
      const nivelDB = String(t.Nivel ?? "").trim().toUpperCase();

      const estanteMatch = !estanteInput || estanteDB === estanteInput;
      const seccionMatch = !seccionInput || seccionDB === seccionInput;
      const nivelMatch = !nivelInput || nivelDB === nivelInput;

      return estanteMatch && seccionMatch && nivelMatch;
    });

    const data = resultado.map((p) => ({
      number_tag: p.number_tag,
      Codigo: p.ItemCode,
      Descripcion: p.Dscription,
      Conteo: 0
    }));

    const map = {};
    data.forEach((item, i) => {
      map[item.number_tag] = i;
    });

    this.setState({
      ubicacionData: data,
      ubicacionDataMap: map
    });

    Swal.fire({
      icon: data.length > 0 ? "success" : "warning",
      title: "Resultado",
      text: `${data.length} productos encontrados`
    });
  };

  addOrIncrementUbicacionItem = async (number_tag, cantidad = 1) => {
    const { ubicacionData, ubicacionDataMap, existingTagsMap } = this.state;
    const tag = this.normalize(number_tag);
    const producto = existingTagsMap[tag];

    if (!producto) {
      Swal.fire("Error", `Tag ${tag} no encontrado`, "error");
      return;
    }

    const index = ubicacionDataMap[tag];

    if (index !== undefined) {
      const data = [...ubicacionData];
      data[index].Conteo = parseFloat(data[index].Conteo || 0) + parseFloat(cantidad || 0);
      const updatedItem = data.splice(index, 1)[0];
      data.unshift(updatedItem);

      const map = {};
      data.forEach((item, i) => {
        map[item.number_tag] = i;
      });

      this.setState({ ubicacionData: data, ubicacionDataMap: map });
      return;
    }

    const newItem = {
      number_tag: tag,
      Codigo: producto.ItemCode,
      Descripcion: producto.Dscription,
      Conteo: parseFloat(cantidad || 0)
    };

    const data = [newItem, ...ubicacionData];
    const map = {};
    data.forEach((item, i) => {
      map[item.number_tag] = i;
    });

    this.setState({ ubicacionData: data, ubicacionDataMap: map });
  };

  handleBarcodeKeyPress = async (e) => {
    if (e.key === "Enter") {
      const tag = this.state.barcodeInput.trim().toUpperCase();
      if (!tag) return;

      await this.addOrIncrementItem(tag);

      this.setState({ barcodeInput: "" }, () => {
        if (barcodeRef.current) barcodeRef.current.focus();
      });
    }
  };

  handleBarcodeUbicacionKeyPress = async (e) => {
    if (e.key === "Enter") {
      const tag = this.state.barcodeUbicacion.trim().toUpperCase();
      if (!tag) return;

      const { existingTagsMap } = this.state;
      const producto = existingTagsMap[tag];

      if (!producto) {
        Swal.fire("Error", "Tag no existe", "error");
        return;
      }

      const { ubicacionEstante, ubicacionSeccion, ubicacionNivel } = this.state;
      const estanteInput = String(ubicacionEstante ?? "").trim().toUpperCase();
      const seccionInput = String(ubicacionSeccion ?? "").trim().toUpperCase();
      const nivelInput = String(ubicacionNivel ?? "").trim().toUpperCase();

      const estanteTag = String(producto.Estante ?? "").trim().toUpperCase();
      const seccionTag = String(producto.Seccion ?? "").trim().toUpperCase();
      const nivelTag = String(producto.Nivel ?? "").trim().toUpperCase();

      if (estanteTag !== estanteInput || seccionTag !== seccionInput || nivelTag !== nivelInput) {
        Swal.fire({
          icon: "warning",
          title: "Ubicación incorrecta",
          html: `
            Este Código no pertenece a esta ubicación<br/><br/>
            <b>Ubicación real:</b><br/>
            Estante: ${producto.Estante || "NULL"}<br/>
            Sección: ${producto.Seccion || "NULL"}<br/>
            Nivel: ${producto.Nivel || "NULL"}
          `
        });
        this.setState({ barcodeUbicacion: "" });
        return;
      }

      await this.addOrIncrementUbicacionItem(tag, 1);

      this.setState({ barcodeUbicacion: "" }, () => {
        if (barcodeUbicacionRef.current) barcodeUbicacionRef.current.focus();
      });
    }
  };

  buscarCodigoManual = (e) => {
    const valor = e.target.value.toUpperCase();
    const { existingTagsMap } = this.state;

    if (!valor) {
      this.setState({
        codigoManual: "",
        resultadosCodigo: []
      });
      return;
    }

    const resultados = Object.values(existingTagsMap).filter(
      (item) => item.ItemCode && item.ItemCode.toUpperCase().includes(valor)
    );

    this.setState({
      codigoManual: valor,
      resultadosCodigo: resultados.slice(0, 20)
    });
  };

  buscarCodigoUbicacionManual = (e) => {
    const valor = e.target.value.toUpperCase();
    const { existingTagsMap } = this.state;

    if (!valor) {
      this.setState({
        itemCodeUbicacionSearch: "",
        resultadosCodigoUbicacion: []
      });
      return;
    }

    const resultados = Object.values(existingTagsMap).filter(
      (item) => item.ItemCode && item.ItemCode.toUpperCase().includes(valor)
    );

    this.setState({
      itemCodeUbicacionSearch: valor,
      resultadosCodigoUbicacion: resultados.slice(0, 20)
    });
  };

  seleccionarCodigoManual = (tag) => {
    this.addOrIncrementItem(tag);
    this.setState({
      codigoManual: "",
      resultadosCodigo: []
    });
  };

  seleccionarCodigoUbicacion = async (tag) => {
    const normalizedTag = this.normalize(tag);
    const producto = this.state.existingTagsMap[normalizedTag];

    if (!producto) {
      Swal.fire("Error", "Tag no existe", "error");
      return;
    }

    const { ubicacionEstante, ubicacionSeccion, ubicacionNivel } = this.state;
    const estanteInput = String(ubicacionEstante ?? "").trim().toUpperCase();
    const seccionInput = String(ubicacionSeccion ?? "").trim().toUpperCase();
    const nivelInput = String(ubicacionNivel ?? "").trim().toUpperCase();

    const estanteTag = String(producto.Estante ?? "").trim().toUpperCase();
    const seccionTag = String(producto.Seccion ?? "").trim().toUpperCase();
    const nivelTag = String(producto.Nivel ?? "").trim().toUpperCase();

    if (
      (estanteInput && estanteTag !== estanteInput) ||
      (seccionInput && seccionTag !== seccionInput) ||
      (nivelInput && nivelTag !== nivelInput)
    ) {
      Swal.fire({
        icon: "warning",
        title: "Ubicación incorrecta",
        html: `
          Este Código no pertenece a la ubicación filtrada.<br/><br/>
          <b>Ubicación real:</b><br/>
          Estante: ${producto.Estante || "NULL"}<br/>
          Sección: ${producto.Seccion || "NULL"}<br/>
          Nivel: ${producto.Nivel || "NULL"}
        `
      });
      return;
    }

    await this.addOrIncrementUbicacionItem(normalizedTag, 1);
    this.setState({
      itemCodeUbicacionSearch: "",
      resultadosCodigoUbicacion: []
    });
  };

  addOrIncrementItem = async (number_tag, cantidad = 1) => {
    const { existingTagsMap } = this.state;
    const tag = this.normalize(number_tag);
    this.setState({ isLoading: true });

    try {
      const producto = existingTagsMap[tag];
      if (!producto) {
        Swal.fire("Error", `Tag ${tag} no encontrado`, "error");
        return;
      }

      this.setState(
        (prevState) => {
          const existingIndex = prevState.dataMap[tag];

          if (existingIndex !== undefined) {
            const updatedData = [...prevState.data];
            const existingItem = updatedData[existingIndex];
            updatedData[existingIndex] = {
              ...existingItem,
              Conteo: parseFloat(existingItem.Conteo) + parseFloat(cantidad)
            };

            const updatedItem = updatedData.splice(existingIndex, 1)[0];
            updatedData.unshift(updatedItem);

            const newMap = {};
            updatedData.forEach((item, i) => {
              newMap[item.number_tag] = i;
            });

            return {
              data: updatedData,
              dataMap: newMap
            };
          }

          const newItem = {
            number_tag: tag,
            Codigo: producto.ItemCode || "",
            Descripcion: producto.Dscription || "",
            location_desc_tag: producto.location_desc_tag || "",
            Estante: producto.Estante || "",
            Seccion: producto.Seccion || "",
            Nivel: producto.Nivel || "",
            Conteo: parseFloat(cantidad),
            createdAt: Date.now(),
            stockSAP: ""
          };

          const newData = [newItem, ...prevState.data];
          const newMap = {};
          newData.forEach((item, i) => {
            newMap[item.number_tag] = i;
          });

          return {
            data: newData,
            dataMap: newMap
          };
        },
        () => {
          this.saveToLocalBackup();
          this.setState(
            (prev) => ({
              autoSaveCounter: prev.autoSaveCounter + 1
            }),
            () => {
              if (this.state.autoSaveCounter >= 20) {
                this.autoSyncInventario();
              }
            }
          );
        }
      );
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "No se pudo procesar el TAG", "error");
    } finally {
      this.setState({ isLoading: false });
    }
  };

  getRealIndexFromGridRow = (row) => {
    try {
      if (gridRef.current && typeof gridRef.current.getrowdata === "function") {
        const rowData = gridRef.current.getrowdata(row);
        if (rowData && rowData.sourceIndex !== undefined && rowData.sourceIndex !== null) {
          return rowData.sourceIndex;
        }
      }
    } catch (error) {
      console.error("Error obteniendo índice real del grid:", error);
    }
    return null;
  };

  getRealIndexFromUbicacionGridRow = (row) => {
    try {
      if (gridUbicacionRef.current && typeof gridUbicacionRef.current.getrowdata === "function") {
        const rowData = gridUbicacionRef.current.getrowdata(row);
        if (rowData && rowData.sourceIndex !== undefined && rowData.sourceIndex !== null) {
          return rowData.sourceIndex;
        }
      }
    } catch (error) {
      console.error("Error obteniendo índice real del grid de ubicación:", error);
    }

    return row;
  };

  openConteoEditor = async (item, currentValue) => {
    const isMobile = this.state.isMobile;

    const result = await Swal.fire({
      title: "Editar conteo",
      html: `
        <div style="font-size:${isMobile ? "16px" : "14px"}; margin-bottom:10px; text-align:left;">
          <b>${item.Codigo || ""}</b><br/>
          <span>${item.Descripcion || ""}</span>
        </div>
      `,
      input: "text",
      inputLabel: "Cantidad",
      inputValue: String(currentValue ?? 0),
      inputPlaceholder: "Ingrese cantidad",
      showCancelButton: true,
      confirmButtonText: "Guardar",
      cancelButtonText: "Cancelar",
      allowOutsideClick: false,
      allowEscapeKey: true,
      returnFocus: false,
      width: isMobile ? "95%" : "32rem",
      inputAttributes: {
        inputmode: "decimal",
        pattern: "[0-9]*[.,]?[0-9]*",
        autocapitalize: "off",
        autocorrect: "off",
        autocomplete: "off"
      },
      didOpen: () => {
        const input = Swal.getInput();
        if (input) {
          input.focus();
          input.click();

          const val = input.value || "";
          const len = val.length;

          if (isMobile) {
            input.style.fontSize = "20px";
            input.style.height = "48px";
            input.style.textAlign = "center";
          }

          setTimeout(() => {
            input.focus();
            input.click();
            try {
              input.setSelectionRange(len, len);
            } catch (e) {}
          }, 80);
        }
      },
      preConfirm: (value) => {
        const normalized = String(value || "").trim().replace(",", ".");

        if (normalized === "" || isNaN(normalized) || parseFloat(normalized) < 0) {
          Swal.showValidationMessage("Ingrese un número válido mayor o igual a 0");
          return false;
        }

        return parseFloat(normalized);
      }
    });

    return result;
  };

  handleEditRow = async (index) => {
    if (this.isSwalOpen) return;

    if (this.state.finalizado) {
      Swal.fire("Inventario cerrado", "No se puede editar un inventario finalizado.", "warning");
      return;
    }

    const item = this.state.data[index];
    if (!item) {
      Swal.fire("Error", "No se encontró la fila seleccionada.", "error");
      return;
    }

    this.isSwalOpen = true;

    try {
      const result = await this.openConteoEditor(item, item.Conteo);

      if (result.isConfirmed && result.value !== undefined) {
        const updatedData = [...this.state.data];
        updatedData[index].Conteo = result.value;

        const newMap = {};
        updatedData.forEach((row, i) => {
          newMap[row.number_tag] = i;
        });

        this.setState(
          {
            data: updatedData,
            dataMap: newMap
          },
          () => {
            this.saveToLocalBackup();
          }
        );
      }
    } finally {
      this.isSwalOpen = false;
    }
  };

  handleDeleteRow = async (index) => {
    if (this.isSwalOpen) return;

    if (this.state.finalizado) {
      Swal.fire("Inventario cerrado", "No se puede eliminar en un inventario finalizado.", "warning");
      return;
    }

    const item = this.state.data[index];
    if (!item) {
      Swal.fire("Error", "No se encontró la fila seleccionada.", "error");
      return;
    }

    this.isSwalOpen = true;

    try {
      const result = await Swal.fire({
        title: "Eliminar línea",
        text: "¿Está seguro de eliminar esta línea?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar",
        allowOutsideClick: false,
        allowEscapeKey: true
      });

      if (result.isConfirmed) {
        this.setState(
          (prevState) => {
            const updatedData = prevState.data.filter((_, i) => i !== index);

            const newMap = {};
            updatedData.forEach((item, i) => {
              newMap[item.number_tag] = i;
            });

            return {
              data: updatedData,
              dataMap: newMap
            };
          },
          () => {
            this.saveToLocalBackup();
          }
        );
      }
    } finally {
      this.isSwalOpen = false;
    }
  };

  handleEditUbicacionRow = async (index) => {
    if (this.isSwalOpen) return;

    const item = this.state.ubicacionData[index];
    if (!item) {
      Swal.fire("Error", "No se encontró la fila seleccionada.", "error");
      return;
    }

    this.isSwalOpen = true;

    try {
      const result = await this.openConteoEditor(item, item.Conteo);

      if (result.isConfirmed && result.value !== undefined) {
        const updatedData = [...this.state.ubicacionData];
        updatedData[index].Conteo = result.value;

        const newMap = {};
        updatedData.forEach((row, i) => {
          newMap[row.number_tag] = i;
        });

        this.setState({ ubicacionData: updatedData, ubicacionDataMap: newMap });
      }
    } finally {
      this.isSwalOpen = false;
    }
  };

  handleDeleteUbicacionRow = async (index) => {
    if (this.isSwalOpen) return;

    const item = this.state.ubicacionData[index];
    if (!item) {
      Swal.fire("Error", "No se encontró la fila seleccionada.", "error");
      return;
    }

    this.isSwalOpen = true;

    try {
      const result = await Swal.fire({
        title: "Eliminar línea de ubicación",
        text: "¿Está seguro de eliminar esta línea?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar",
        allowOutsideClick: false,
        allowEscapeKey: true
      });

      if (result.isConfirmed) {
        const updatedData = this.state.ubicacionData.filter((_, i) => i !== index);
        const newMap = {};
        updatedData.forEach((row, i) => {
          newMap[row.number_tag] = i;
        });

        this.setState({ ubicacionData: updatedData, ubicacionDataMap: newMap });
      }
    } finally {
      this.isSwalOpen = false;
    }
  };

  safeStr = (v) => (v === null || v === undefined ? "" : String(v));

  fmtDate = (iso) => {
    if (!iso) return "Sin fecha";
    const d = new Date(iso);
    if (isNaN(d.getTime())) return this.safeStr(iso);
    return d.toLocaleString("es-GT");
  };

  fmtDateOnly = (iso) => {
    if (!iso) return "Sin fecha";
    const d = new Date(iso);
    if (isNaN(d.getTime())) return this.safeStr(iso);

    const dia = String(d.getDate()).padStart(2, "0");
    const mes = String(d.getMonth() + 1).padStart(2, "0");
    const anio = d.getFullYear();

    return `${dia}/${mes}/${anio}`;
  };

  nuevoInventario = async () => {
    if (this.state.data.length > 0) {
      const result = await Swal.fire({
        title: "Inventario en proceso",
        text: "¿Desea guardar antes de crear uno nuevo?",
        icon: "question",
        showCancelButton: true,
        showDenyButton: true,
        confirmButtonText: "💾 Guardar",
        denyButtonText: "🗑 Descartar",
        cancelButtonText: "Cancelar"
      });

      if (result.isConfirmed) {
        await this.guardarComoBorrador();
      }

      if (result.dismiss === Swal.DismissReason.cancel) {
        return;
      }
    }

    localStorage.removeItem(this.state.backupKey);

    this.setState({
      IdDocInventario: "",
      FechaDocumento: moment().format("YYYY-MM-DD"),
      Usuario: this.state.Usuario,
      Estado: "BORRADOR",
      Comments: "",
      data: [],
      dataMap: {},
      inventarioActual: null,
      finalizado: false,
      autoSaveCounter: 0
    });

    if (!this.state.isMobile && barcodeRef.current) {
      setTimeout(() => {
        barcodeRef.current.focus();
      }, 200);
    }
  };

  guardarInventario = async () => {
    if (this.state.data.length === 0) {
      Swal.fire("Aviso", "No hay productos para guardar.", "warning");
      return;
    }

    const usuarioNum = this.getNumericUserId();
    if (usuarioNum === null) {
      Swal.fire("Aviso", "Usuario inválido (debe ser numérico).", "warning");
      return;
    }

    this.setState({ isLoading: true });

    try {
      const hoy = moment().format("YYYYMMDD");

      const documentsLines = this.state.data.map((item) => ({
        Codigo: item.Codigo,
        Descripcion: item.Descripcion,
        Tag: item.number_tag,
        location_desc_tag: item.location_desc_tag,
        Estante: item.Estante,
        Seccion: item.Seccion,
        Nivel: item.Nivel,
        Conteo: String(item.Conteo)
      }));

      const estadoBackend = "C";

      if (!this.state.inventarioActual?.IdDocInventario) {
        const payload = {
          fechaCreacion: hoy,
          fechaDocumento: moment(this.state.FechaDocumento).format("YYYYMMDD"),
          fechaActualizacion: hoy,
          Usuario: usuarioNum,
          Comentario: this.state.Comments,
          Estado: estadoBackend,
          documentsLines
        };

        const response = await fetch(`${dominio}/postInventario`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload)
        });

        const body = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(body?.error || body?.detail || "Error al crear inventario");

        const dataPost = body?.data && Array.isArray(body.data) ? body.data[0] : body;

        this.setState({
          inventarioActual: dataPost,
          IdDocInventario: dataPost.IdDocInventario,
          FechaCreacion: moment(dataPost.fechaCreacion || payload.fechaCreacion, "YYYYMMDD").format("YYYY-MM-DD"),
          FechaActualizacion: moment(dataPost.fechaActualizacion || payload.fechaActualizacion, "YYYYMMDD").format("YYYY-MM-DD")
        });

        Swal.fire("Éxito", "Inventario creado correctamente", "success");
      } else {
        const payload = {
          IdDocInventario: this.state.inventarioActual.IdDocInventario,
          Estado: "C",
          Comentario: this.state.Comments,
          Usuario: usuarioNum,
          fechaDocumento: moment(this.state.FechaDocumento).format("YYYYMMDD"),
          documentsLines
        };

        const response = await fetch(`${dominio}/patchInventario`, {
          method: "PATCH",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload)
        });

        const dataPatch = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(dataPatch?.error || dataPatch?.detail || "Error al actualizar inventario");

        const lista = await this.cargarInventariosGuardados();
        const id = this.state.inventarioActual?.IdDocInventario;

        const invActualizado = (lista || []).find((x) => String(x.IdDocInventario) === String(id));

        this.setState({
          FechaActualizacion: invActualizado?.fechaActualizacion
            ? moment(String(invActualizado.fechaActualizacion), "YYYYMMDD").format("YYYY-MM-DD")
            : dataPatch.fechaActualizacion
            ? moment(String(dataPatch.fechaActualizacion), "YYYYMMDD").format("YYYY-MM-DD")
            : ""
        });

        Swal.fire("Éxito", "Inventario actualizado correctamente", "success");
      }

      this.setState({
        Estado: "CERRADO",
        finalizado: true
      });

      localStorage.removeItem(this.state.backupKey);
      this.cargarInventariosGuardados();
    } catch (error) {
      console.error(error);
      Swal.fire("Error", error?.message || "No se pudo guardar en el servidor", "error");
    } finally {
      this.setState({ isLoading: false });
    }
  };

  guardarComoBorrador = async () => {
    if (!Array.isArray(this.state.data) || this.state.data.length === 0) {
      Swal.fire("Aviso", "No hay datos para guardar.", "warning");
      return;
    }

    const fechaDocMoment = moment(this.state.FechaDocumento, ["YYYY-MM-DD", moment.ISO_8601], true);

    if (!fechaDocMoment.isValid()) {
      Swal.fire("Aviso", "FechaDocumento inválida.", "warning");
      return;
    }

    const usuarioNum = this.getNumericUserId();
    if (!Number.isFinite(usuarioNum)) {
      Swal.fire("Aviso", "Usuario inválido (debe ser numérico).", "warning");
      return;
    }

    const documentsLines = this.state.data.map((item) => ({
      Codigo: item.Codigo,
      Descripcion: item.Descripcion,
      Tag: item.number_tag,
      location_desc_tag: item.location_desc_tag,
      Estante: item.Estante,
      Seccion: item.Seccion,
      Nivel: item.Nivel,
      Conteo: String(item.Conteo ?? "")
    }));

    if (!Array.isArray(documentsLines) || documentsLines.length === 0) {
      Swal.fire("Aviso", "documentsLines está vacío.", "warning");
      return;
    }

    let idInventario = this.state.inventarioActual?.IdDocInventario;

    const fetchJsonOrText = async (url, options) => {
      const resp = await fetch(url, options);
      const raw = await resp.text();
      let parsed = raw;
      try {
        parsed = JSON.parse(raw);
      } catch (_) {}
      return { resp, raw, parsed };
    };

    const hoy = moment().format("YYYYMMDD");

    if (!idInventario) {
      this.setState({ isLoading: true });

      try {
        const payloadPost = {
          fechaCreacion: hoy,
          fechaDocumento: fechaDocMoment.format("YYYYMMDD"),
          fechaActualizacion: hoy,
          Usuario: usuarioNum,
          Comentario: this.state.Comments ?? null,
          Estado: "D",
          documentsLines
        };

        const { resp, parsed } = await fetchJsonOrText(`${dominio}/postInventario`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payloadPost)
        });

        if (!resp.ok) {
          console.error("POST /postInventario error:", resp.status, parsed);
          Swal.fire("Error", parsed?.error || "No se pudo guardar", "error");
          return;
        }

        const inventarioCreado = parsed?.data && Array.isArray(parsed.data) ? parsed.data[0] : parsed;

        idInventario = inventarioCreado?.IdDocInventario;

        if (!idInventario) {
          console.error("Respuesta inesperada POST:", parsed);
          Swal.fire("Error", "La respuesta del servidor no devolvió IdDocInventario.", "error");
          return;
        }

        this.setState({
          inventarioActual: {
            ...(inventarioCreado || {}),
            IdDocInventario: idInventario
          },
          IdDocInventario: idInventario,
          FechaCreacion: moment(payloadPost.fechaCreacion, "YYYYMMDD").format("YYYY-MM-DD"),
          FechaActualizacion: moment(payloadPost.fechaActualizacion, "YYYYMMDD").format("YYYY-MM-DD")
        });

        Swal.fire("Guardado", "Borrador creado con éxito.", "success");
        localStorage.removeItem(this.state.backupKey);

        await this.cargarInventariosGuardados();
        return;
      } catch (error) {
        console.error(error);
        Swal.fire("Error", error?.message || "No se pudo guardar", "error");
        return;
      } finally {
        this.setState({ isLoading: false });
      }
    }

    this.setState({ isLoading: true });

    try {
      const payloadPatch = {
        IdDocInventario: this.state.inventarioActual?.IdDocInventario || idInventario,
        Estado: "D",
        Comentario: this.state.Comments ?? null,
        Usuario: usuarioNum,
        fechaDocumento: fechaDocMoment.format("YYYYMMDD"),
        documentsLines
      };

      const { resp, parsed } = await fetchJsonOrText(`${dominio}/patchInventario`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payloadPatch)
      });

      if (!resp.ok) {
        console.error("PATCH /patchInventario error:", resp.status, parsed);
        Swal.fire("Error", parsed?.error || "No se pudo guardar", "error");
        return;
      }

      if (parsed?.fechaActualizacion) {
        this.setState({
          FechaActualizacion: moment(parsed.fechaActualizacion, "YYYYMMDD").format("YYYY-MM-DD")
        });
      }

      Swal.fire("Guardado", "Inventario guardado con éxito.", "success");
      localStorage.removeItem(this.state.backupKey);

      const lista = await this.cargarInventariosGuardados();
      const id = this.state.inventarioActual?.IdDocInventario || idInventario;
      const invActualizado = (lista || []).find((x) => String(x.IdDocInventario) === String(id));

      this.setState({
        FechaActualizacion: invActualizado?.fechaActualizacion
          ? moment(String(invActualizado.fechaActualizacion), "YYYYMMDD").format("YYYY-MM-DD")
          : this.state.FechaActualizacion
      });
    } catch (error) {
      console.error(error);
      Swal.fire("Error", error?.message || "No se pudo guardar", "error");
    } finally {
      this.setState({ isLoading: false });
    }
  };

  cargarInventariosGuardados = async () => {
    try {
      const res = await fetch(`${dominio}/getInventario`);

      if (!res.ok) throw new Error("Error GET inventarios");

      const inventarios = await res.json();

      this.setState({ inventariosGuardados: inventarios });
      return inventarios;
    } catch (error) {
      console.error("Error cargando inventarios:", error);
      return [];
    }
  };

  abrirInventario = (inventario) => {
    const detalleTransformado = (inventario.documentsLines || []).map((item) => ({
      number_tag: item.Tag,
      Codigo: item.Codigo || item.ItemCode || "",
      Descripcion: item.Descripcion,
      location_desc_tag: item.location_desc_tag || "",
      Estante: item.Estante,
      Seccion: item.Seccion,
      Nivel: item.Nivel,
      Conteo: parseFloat(item.Conteo || 0),
      createdAt: Date.now(),
      stockSAP: ""
    }));

    const dataMap = {};
    detalleTransformado.forEach((item, index) => {
      dataMap[item.number_tag] = index;
    });

    this.setState(
      {
        inventarioActual: inventario,
        IdDocInventario: inventario.IdDocInventario,
        FechaDocumento: moment(inventario.fechaDocumento, "YYYYMMDD").format("YYYY-MM-DD"),
        FechaCreacion: inventario.fechaCreacion
          ? moment(String(inventario.fechaCreacion), ["YYYYMMDD", "YYYY-MM-DD"]).format("YYYY-MM-DD")
          : "",
        FechaActualizacion: inventario.fechaActualizacion
          ? moment(String(inventario.fechaActualizacion), ["YYYYMMDD", "YYYY-MM-DD"]).format("YYYY-MM-DD")
          : "",
        Usuario: inventario.Usuario,
        Estado: inventario.Estado === "C" ? "CERRADO" : "BORRADOR",
        Comments: inventario.Comentario,
        data: detalleTransformado,
        dataMap: dataMap,
        finalizado: inventario.Estado === "C"
      },
      () => {
        const codes = detalleTransformado.map((item) => item.Codigo).filter(Boolean);
        this.fetchStockForItems(codes);
      }
    );
  };

  localization = {
    pagergotopagestring: "Ir a página:",
    pagershowrowsstring: "Mostrar filas:",
    pagerrangestring: " de ",
    pagerpreviousbuttonstring: "Anterior",
    pagernextbuttonstring: "Siguiente",
    groupsheaderstring: "Arrastre una columna aquí para agrupar",
    sortascendingstring: "Orden ascendente",
    sortdescendingstring: "Orden descendente",
    sortremovestring: "Quitar orden",
    emptydatastring: "No hay datos disponibles"
  };

  saveToLocalBackup = () => {
    const backupData = {
      header: {
        IdDocInventario: this.state.IdDocInventario,
        FechaDocumento: this.state.FechaDocumento,
        Usuario: this.state.Usuario,
        currentUserId: this.state.currentUserId,
        Estado: this.state.Estado,
        Comments: this.state.Comments,
        FechaCreacion: this.state.FechaCreacion,
        FechaActualizacion: this.state.FechaActualizacion
      },
      data: this.state.data,
      inventarioActual: this.state.inventarioActual
    };

    localStorage.setItem(this.state.backupKey, JSON.stringify(backupData));
  };

  loadLocalBackup = () => {
    const backup = localStorage.getItem(this.state.backupKey);
    if (!backup) return;

    try {
      const parsed = JSON.parse(backup);

      const dataMap = {};
      (parsed.data || []).forEach((item, index) => {
        dataMap[item.number_tag] = index;
      });

      this.setState(
        {
          ...parsed.header,
          data: parsed.data || [],
          dataMap,
          inventarioActual: parsed.inventarioActual || null
        },
        () => {
          const codes = (this.state.data || []).map((item) => item.Codigo).filter(Boolean);
          this.fetchStockForItems(codes);
        }
      );

      Swal.fire("Recuperado", "Se recuperó un inventario guardado automáticamente.", "info");
    } catch (error) {
      console.error("Error cargando backup:", error);
    }
  };

  agregarUbicacionAlInventario = async () => {
    const { ubicacionData } = this.state;

    if (ubicacionData.length === 0) {
      Swal.fire("Aviso", "No hay datos para agregar", "warning");
      return;
    }

    for (const item of ubicacionData) {
      const cantidad = parseFloat(item.Conteo);
      if (cantidad > 0) {
        await this.addOrIncrementItem(item.number_tag, cantidad);
      }
    }

    Swal.fire("Éxito", "Conteo agregado al inventario", "success");
  };

  autoSyncInventario = async () => {
    if (!this.state.inventarioActual?.IdDocInventario) return;

    const usuarioNum = this.getNumericUserId();
    if (usuarioNum === null) return;

    this.setState({ isSyncing: true });

    try {
      const documentsLines = this.state.data.map((item) => ({
        Codigo: item.Codigo,
        Descripcion: item.Descripcion,
        Tag: item.number_tag,
        location_desc_tag: item.location_desc_tag,
        Estante: item.Estante,
        Seccion: item.Seccion,
        Nivel: item.Nivel,
        Conteo: String(item.Conteo)
      }));

      await fetch(`${dominio}/patchInventario`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          IdDocInventario: this.state.inventarioActual.IdDocInventario,
          Estado: "D",
          Comentario: this.state.Comments,
          Usuario: usuarioNum,
          fechaDocumento: moment(this.state.FechaDocumento).format("YYYYMMDD"),
          documentsLines
        })
      });

      this.setState({ autoSaveCounter: 0 });
    } catch (error) {
      console.error("Error autosync:", error);
    } finally {
      this.setState({ isSyncing: false });
    }
  };

  fetchStockForItems = async (itemCodes) => {
    if (!Array.isArray(itemCodes) || itemCodes.length === 0) return;
    const newCodes = [...new Set(itemCodes)].filter(
      (code) => code && !(code in this.state.stockSAPMap)
    );
    console.log("[SAP] fetchStockForItems llamado. Códigos a buscar:", newCodes);
    if (newCodes.length === 0) return;

    const results = await Promise.all(
      newCodes.map(async (code) => {
        try {
          const url = `${dominio}/SGIM_StockGlobalArticulo?ItemCode=${encodeURIComponent(code)}`;
          console.log("[SAP] Fetching:", url);
          const res = await fetch(url, {
            headers: { "API-Key": "b4ed47a3-b372-49df-a200-2e68d5f7a454" }
          });
          console.log("[SAP] Status para", code, ":", res.status);
          if (!res.ok) return { code, stock: null };
          const body = await res.json();
          console.log("[SAP] Respuesta para", code, ":", JSON.stringify(body));
          // Respuesta: { answer, code, data: { ItemCode, ItemName, Stock } }
          const raw = body?.data ?? (Array.isArray(body) ? body[0] : body);
          const stock = raw?.Stock ?? raw?.OnHand ?? raw?.Quantity ?? raw?.InStock ?? null;
          console.log("[SAP] Stock extraído para", code, ":", stock);
          return {
            code,
            stock: stock !== null && stock !== undefined ? parseFloat(stock) : null
          };
        } catch (err) {
          console.error("[SAP] Error para", code, ":", err);
          return { code, stock: null };
        }
      })
    );

    // Mapa code → string para actualizar data
    const codeToSAP = {};
    results.forEach(({ code, stock }) => {
      codeToSAP[code] = stock !== null ? String(stock) : "";
    });

    // Actualizar stockSAPMap para evitar re-fetches
    const newSAPMap = { ...this.state.stockSAPMap };
    results.forEach(({ code, stock }) => {
      newSAPMap[code] = stock;
    });

    // Embeber stockSAP directamente en data para que el grid se refresque
    const updatedData = this.state.data.map((item) =>
      item.Codigo in codeToSAP
        ? { ...item, stockSAP: codeToSAP[item.Codigo] }
        : item
    );

    this.setState({ stockSAPMap: newSAPMap, data: updatedData }, () => {
      try {
        if (gridRef.current && typeof gridRef.current.updatebounddata === "function") {
          gridRef.current.updatebounddata("cells");
        }
      } catch (e) {}
    });
  };

  renderCreateTagModal() {
    const { showCreateTagModal, createTagForm, createTagError, isLoading, isItemsLoading, availableItems } = this.state;

    return (
      <Modal show={showCreateTagModal} onHide={this.closeCreateTagModal} backdrop={isLoading ? "static" : true}>
        <Modal.Header closeButton={!isLoading}>
          <Modal.Title>Crear Tag</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {createTagError ? (
            <Alert bsStyle="danger" style={{ marginBottom: 15 }}>
              {createTagError}
            </Alert>
          ) : null}

          <FormGroup>
            <ControlLabel>Código *</ControlLabel>
            <input
              ref={itemCodeCreateTagRef}
              type="text"
              className="form-control"
              value={createTagForm.ItemCode}
              onChange={(e) => this.onCreateTagItemCodeChange(e.target.value)}
              placeholder={isItemsLoading ? "Cargando items..." : "Escribí o seleccioná ItemCode"}
              list="inventario-itemcodes"
              disabled={isLoading}
            />
            <datalist id="inventario-itemcodes">
              {availableItems.map((it) => (
                <option key={it.ItemCode} value={it.ItemCode}>
                  {it.ItemName}
                </option>
              ))}
            </datalist>
          </FormGroup>

          <FormGroup>
            <ControlLabel>Descripción *</ControlLabel>
            <input
              ref={dscriptionCreateTagRef}
              type="text"
              className="form-control"
              value={createTagForm.Dscription}
              onChange={(e) => this.onCreateTagFormChange("Dscription", e.target.value)}
              placeholder="Descripción"
              disabled={isLoading}
            />
          </FormGroup>

          <Row>
            <Col md={4}>
              <FormGroup>
                <ControlLabel>Estante</ControlLabel>
                <select
                  className="form-control"
                  value={createTagForm.Estante || ""}
                  onChange={(e) => this.onCreateTagFormChange("Estante", e.target.value)}
                  disabled={isLoading}
                >
                  <option value="">-- Seleccionar --</option>
                  {ESTANTES.map((x) => (
                    <option key={x} value={x}>
                      {x}
                    </option>
                  ))}
                </select>
              </FormGroup>
            </Col>

            <Col md={4}>
              <FormGroup>
                <ControlLabel>Sección</ControlLabel>
                <select
                  className="form-control"
                  value={createTagForm.Seccion || ""}
                  onChange={(e) => this.onCreateTagFormChange("Seccion", e.target.value)}
                  disabled={isLoading}
                >
                  <option value="">(Vacío)</option>
                  {SECCIONES.filter((x) => x !== "").map((x) => (
                    <option key={x} value={x}>
                      {x}
                    </option>
                  ))}
                </select>
              </FormGroup>
            </Col>

            <Col md={4}>
              <FormGroup>
                <ControlLabel>Nivel</ControlLabel>
                <input
                  type="number"
                  className="form-control"
                  value={createTagForm.Nivel || ""}
                  onChange={(e) => {
                    const v = e.target.value;
                    if (v === "" || /^[0-9]+$/.test(v)) {
                      this.onCreateTagFormChange("Nivel", v);
                    }
                  }}
                  placeholder="Solo número"
                  min="0"
                  step="1"
                  disabled={isLoading}
                />
              </FormGroup>
            </Col>
          </Row>
        </Modal.Body>

        <Modal.Footer>
          <Button onClick={this.closeCreateTagModal} disabled={isLoading}>
            Cancelar
          </Button>
          <Button bsStyle="success" onClick={this.createTagFromModal} disabled={isLoading}>
            {isLoading ? "Guardando..." : "Guardar"}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  render() {
    const { data, isMobile, inventariosGuardados, stockSAPMap,
      listaFiltroTexto, listaFiltroFechaDesde, listaFiltroFechaHasta } = this.state;

    const source = {
      localdata: data.map((item, index) => ({
        ...item,
        rowIndex: index,
        sourceIndex: index,
        stockSAP: item.stockSAP || ""
      })),
      datatype: "array",
      datafields: [
        { name: "number_tag", type: "string" },
        { name: "Codigo", type: "string" },
        { name: "Descripcion", type: "string" },
        { name: "location_desc_tag", type: "string" },
        { name: "Estante", type: "string" },
        { name: "Seccion", type: "string" },
        { name: "Nivel", type: "string" },
        { name: "Conteo", type: "number" },
        { name: "stockSAP", type: "string" },
        { name: "rowIndex", type: "number" },
        { name: "sourceIndex", type: "number" },
        { name: "createdAt", type: "number" }
      ]
    };

    const dataAdapter = new jqx.dataAdapter(source);

    const getCellClass = (row, columnfield, value, rowdata) => {
      const rawStock = rowdata.stockSAP;
      if (rawStock === "" || rawStock === null || rawStock === undefined) return "inv-row-pending";
      const stock = parseFloat(rawStock);
      if (isNaN(stock)) return "inv-row-pending";
      if (stock === 0) return "inv-row-zero";
      const conteo = parseFloat(rowdata.Conteo) || 0;
      return Math.abs(conteo - stock) < 0.001 ? "inv-row-match" : "inv-row-mismatch";
    };

    const columns = [
      {
        text: "Editar",
        datafield: "Editar",
        columntype: "button",
        width: 60,
        cellsrenderer: () => "✏️",
        buttonclick: (row) => {
          const realIndex = this.getRealIndexFromGridRow(row);
          if (realIndex === null) return;
          this.handleEditRow(realIndex);
        }
      },
      {
        text: "Eliminar",
        datafield: "Eliminar",
        columntype: "button",
        width: 60,
        cellsrenderer: () => "🗑️",
        buttonclick: (row) => {
          const realIndex = this.getRealIndexFromGridRow(row);
          if (realIndex === null) return;
          this.handleDeleteRow(realIndex);
        }
      },
      { text: "Código", datafield: "Codigo", minwidth: 100, cellsalign: "center", align: "center", cellclassname: getCellClass },
      { text: "Conteo", datafield: "Conteo", minwidth: 60, cellsalign: "center", align: "center", cellsformat: "f2", cellclassname: getCellClass },
      {
        text: "Stock SAP",
        datafield: "stockSAP",
        minwidth: 80,
        cellsalign: "center",
        align: "center",
        hidden: true,
        cellclassname: getCellClass,
        cellsrenderer: (row, columnfield, value) => {
          if (!value && value !== "0") {
            return '<div style="text-align:center;color:#aaa">—</div>';
          }
          const n = parseFloat(value);
          if (isNaN(n)) return '<div style="text-align:center;color:#aaa">—</div>';
          return `<div style="text-align:center;">${n.toFixed(2)}</div>`;
        }
      },
      { text: "Descripción", datafield: "Descripcion", minwidth: isMobile ? 140 : 180, cellsalign: "left", align: "center", cellclassname: getCellClass },
      { text: "Tag", datafield: "number_tag", minwidth: 120, cellsalign: "center", align: "center", cellclassname: getCellClass, hidden: isMobile },
      { text: "Estante", datafield: "Estante", minwidth: 80, cellsalign: "center", align: "center", cellclassname: getCellClass, hidden: isMobile },
      { text: "Sección", datafield: "Seccion", minwidth: 80, cellsalign: "center", align: "center", cellclassname: getCellClass, hidden: isMobile },
      { text: "Nivel", datafield: "Nivel", minwidth: 80, cellsalign: "center", align: "center", cellclassname: getCellClass, hidden: isMobile },
      { text: "createdAt", datafield: "createdAt", hidden: true },
      { text: "sourceIndex", datafield: "sourceIndex", hidden: true }
    ];

    const ubicacionSource = {
      localdata: this.state.ubicacionData.map((item, index) => ({
        ...item,
        sourceIndex: index
      })),
      datatype: "array",
      datafields: [
        { name: "number_tag", type: "string" },
        { name: "Codigo", type: "string" },
        { name: "Descripcion", type: "string" },
        { name: "Conteo", type: "number" },
        { name: "sourceIndex", type: "number" }
      ]
    };

    return (
      <div className="content" style={{ padding: isMobile ? "5px" : "20px" }}>
        <Grid fluid>
          <Row>
            <Col xs={12}>
              <h3 style={{ textAlign: "center", marginBottom: "20px" }}>Inventario Bodega</h3>

              {isMobile ? (
                /* ── Handheld: tarjeta compacta ── */
                <div style={{
                  background: "#f8fafc",
                  borderRadius: "12px",
                  padding: "12px 14px",
                  marginBottom: "12px",
                  border: "1px solid #dde3ec"
                }}>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px 16px" }}>

                    <div>
                      <div style={{ fontSize: "10px", color: "#888", fontWeight: "700", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "2px" }}>N° Doc</div>
                      <div style={{ fontSize: "14px", fontWeight: "bold", color: "#333" }}>{this.state.IdDocInventario || "—"}</div>
                    </div>

                    <div>
                      <div style={{ fontSize: "10px", color: "#888", fontWeight: "700", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "2px" }}>Estado</div>
                      <span style={{
                        display: "inline-block",
                        padding: "2px 10px",
                        borderRadius: "6px",
                        fontSize: "12px",
                        fontWeight: "bold",
                        background: this.state.Estado === "FINALIZADO" ? "#d4edda" : "#fff3cd",
                        color: this.state.Estado === "FINALIZADO" ? "#155724" : "#856404"
                      }}>{this.state.Estado}</span>
                    </div>

                    <div>
                      <div style={{ fontSize: "10px", color: "#888", fontWeight: "700", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "2px" }}>Usuario</div>
                      <div style={{ fontSize: "13px", color: "#333" }}>{this.state.Usuario || "—"}</div>
                    </div>

                    <div>
                      <div style={{ fontSize: "10px", color: "#888", fontWeight: "700", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "4px" }}>Fecha Doc.</div>
                      <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                        <input
                          ref={fechaDocumentoRef}
                          type="date"
                          className="form-control"
                          style={{ padding: "4px 6px", height: "32px", fontSize: "12px", flex: 1 }}
                          value={this.state.FechaDocumento}
                          onChange={(e) => this.setState({ FechaDocumento: e.target.value })}
                          disabled={this.state.finalizado}
                          readOnly={!this.isInputEditable("FechaDocumento")}
                          onBlur={this.disableMobileKeyboard}
                          onTouchStart={(e) => {
                            if (!this.isInputEditable("FechaDocumento")) e.preventDefault();
                          }}
                        />
                        {this.renderKeyboardButton("FechaDocumento", fechaDocumentoRef, this.state.finalizado)}
                      </div>
                    </div>

                    <div>
                      <div style={{ fontSize: "10px", color: "#888", fontWeight: "700", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "2px" }}>Creación</div>
                      <div style={{ fontSize: "12px", color: this.state.FechaCreacion ? "#333" : "#aaa", fontStyle: this.state.FechaCreacion ? "normal" : "italic" }}>
                        {this.state.FechaCreacion || "Al guardar"}
                      </div>
                    </div>

                    <div>
                      <div style={{ fontSize: "10px", color: "#888", fontWeight: "700", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "2px" }}>Actualización</div>
                      <div style={{ fontSize: "12px", color: this.state.FechaActualizacion ? "#333" : "#aaa", fontStyle: this.state.FechaActualizacion ? "normal" : "italic" }}>
                        {this.state.FechaActualizacion || "Al guardar"}
                      </div>
                    </div>

                  </div>
                </div>
              ) : (
                /* ── Desktop: layout original 2 columnas ── */
                <Row>
                  <Col xs={12} md={6}>
                    <FormGroup>
                      <ControlLabel>No Documento</ControlLabel>
                      <input type="text" className="form-control" value={this.state.IdDocInventario ?? ""} disabled />
                    </FormGroup>

                    <FormGroup>
                      <ControlLabel>Fecha Documento</ControlLabel>
                      {this.renderInputContainer(
                        <>
                          <input
                            ref={fechaDocumentoRef}
                            type="date"
                            className="form-control"
                            value={this.state.FechaDocumento}
                            onChange={(e) => this.setState({ FechaDocumento: e.target.value })}
                            disabled={this.state.finalizado}
                            readOnly={!this.isInputEditable("FechaDocumento")}
                            onBlur={this.disableMobileKeyboard}
                            onTouchStart={(e) => {
                              if (this.state.isMobile && !this.isInputEditable("FechaDocumento")) {
                                e.preventDefault();
                              }
                            }}
                          />
                          {this.renderKeyboardButton("FechaDocumento", fechaDocumentoRef, this.state.finalizado)}
                        </>
                      )}
                    </FormGroup>

                    <FormGroup>
                      <ControlLabel>Fecha Creación</ControlLabel>
                      <input type="text" className="form-control" value={this.state.FechaCreacion || ""} placeholder="Al guardar" disabled />
                    </FormGroup>

                    <FormGroup>
                      <ControlLabel>Fecha Actualización</ControlLabel>
                      <input type="text" className="form-control" value={this.state.FechaActualizacion || ""} placeholder="Al guardar" disabled />
                    </FormGroup>
                  </Col>

                  <Col xs={12} md={6}>
                    <FormGroup>
                      <ControlLabel>Estado</ControlLabel>
                      <input type="text" className="form-control" value={this.state.Estado} disabled />
                    </FormGroup>

                    <FormGroup>
                      <ControlLabel>Usuario</ControlLabel>
                      <input type="text" className="form-control" value={this.state.Usuario} disabled />
                    </FormGroup>
                  </Col>
                </Row>
              )}

              <br />

              <Row>
                <Col xs={12}>
                  <FormGroup>
                    <ControlLabel>Comentario</ControlLabel>
                    <div style={{ display: "flex", alignItems: "flex-start", width: "100%" }}>
                      <textarea
                        ref={commentsRef}
                        className="form-control"
                        rows="2"
                        placeholder="Comentario..."
                        value={this.state.Comments}
                        onChange={(e) => this.setState({ Comments: e.target.value })}
                        disabled={this.state.finalizado}
                        readOnly={!this.isInputEditable("Comments")}
                        onBlur={this.disableMobileKeyboard}
                        onTouchStart={(e) => {
                          if (this.state.isMobile && !this.isInputEditable("Comments")) {
                            e.preventDefault();
                          }
                        }}
                      />
                      {this.renderKeyboardButton("Comments", commentsRef, this.state.finalizado)}
                    </div>
                  </FormGroup>
                </Col>
              </Row>

              <br />

              {this.renderInputContainer(
                <>
                  <input
                    ref={barcodeRef}
                    type="text"
                    value={this.state.barcodeInput}
                    onChange={(e) => this.setState({ barcodeInput: e.target.value })}
                    onKeyDown={this.handleBarcodeKeyPress}
                    placeholder="Escanear TAG..."
                    className="form-control input-lg"
                    style={{ fontSize: "18px" }}
                    autoFocus={!this.state.isMobile}
                    disabled={this.state.finalizado}
                    inputMode={this.state.isMobile && !this.isInputEditable("barcodeInput") ? "none" : "text"}
                    autoComplete="off"
                    autoCorrect="off"
                    spellCheck={false}
                    onBlur={this.disableMobileKeyboard}
                    onTouchStart={(e) => {
                      if (this.state.isMobile && !this.isInputEditable("barcodeInput")) {
                        e.preventDefault();
                        this.focusScanInputWithoutKeyboard(barcodeRef);
                      }
                    }}
                  />
                  {this.renderKeyboardButton("barcodeInput", barcodeRef, this.state.finalizado)}
                </>
              )}

              <div style={{ marginTop: "8px" }}>
                {this.renderInputContainer(
                  <>
                    <input
                      ref={codigoManualRef}
                      className="form-control mt-2"
                      placeholder="Ingresar código..."
                      value={this.state.codigoManual}
                      onChange={this.buscarCodigoManual}
                      readOnly={!this.isInputEditable("codigoManual")}
                      onBlur={this.disableMobileKeyboard}
                      onTouchStart={(e) => {
                        if (this.state.isMobile && !this.isInputEditable("codigoManual")) {
                          e.preventDefault();
                        }
                      }}
                    />
                    {this.renderKeyboardButton("codigoManual", codigoManualRef)}
                  </>
                )}
              </div>

              {this.state.resultadosCodigo.length > 0 && (
                <div
                  style={{
                    border: "1px solid #ddd",
                    borderRadius: "6px",
                    marginTop: "5px",
                    maxHeight: "200px",
                    overflowY: "auto",
                    background: "#fff"
                  }}
                >
                  {this.state.resultadosCodigo.map((item, i) => (
                    <div
                      key={i}
                      style={{
                        padding: "8px",
                        borderBottom: "1px solid #eee",
                        cursor: "pointer"
                      }}
                      onClick={() => this.seleccionarCodigoManual(item.number_tag)}
                    >
                      <b>{item.ItemCode}</b>
                      &nbsp;| TAG: {item.number_tag}
                      <br />
                      <small>
                        Estante: {item.Estante || "-"} | Sección: {item.Seccion || "-"} | Nivel: {item.Nivel || "-"}
                      </small>
                    </div>
                  ))}
                </div>
              )}

              {!!this.state.codigoManual && this.state.resultadosCodigo.length === 0 && !this.state.finalizado && (
                <div style={{ marginTop: 8, textAlign: "left" }}>
                  <Alert bsStyle="warning" style={{ marginBottom: 8 }}>
                    No existe un tag para el ItemCode ingresado.
                  </Alert>
                  <Button bsStyle="success" onClick={() => this.openCreateTagModal(this.state.codigoManual, "inventario")}>
                    Crear tag para {this.state.codigoManual}
                  </Button>
                </div>
              )}

              <br />

              {this.state.finalizado && (
                <div
                  style={{
                    backgroundColor: "#f8d7da",
                    color: "#721c24",
                    padding: "10px",
                    fontWeight: "bold",
                    textAlign: "center",
                    borderRadius: "5px",
                    marginBottom: "10px"
                  }}
                >
                  🔒 INVENTARIO CERRADO - SOLO CONSULTA
                </div>
              )}

              <div style={isMobile ? {
                display: "grid",
                gridTemplateColumns: "1fr 1fr 1fr",
                gap: "8px",
                marginBottom: "10px"
              } : {
                display: "flex",
                gap: "20px",
                marginBottom: "10px",
                alignItems: "center"
              }}>
                <div style={{
                  background: "#e3f2fd",
                  padding: isMobile ? "8px 4px" : "10px 20px",
                  borderRadius: "8px",
                  fontWeight: "bold",
                  fontSize: isMobile ? "13px" : "inherit",
                  textAlign: "center"
                }}>
                  {this.state.data.length} Códigos
                </div>
                <div style={{
                  background: "#e8f5e9",
                  padding: isMobile ? "8px 4px" : "10px 20px",
                  borderRadius: "8px",
                  fontWeight: "bold",
                  fontSize: isMobile ? "13px" : "inherit",
                  textAlign: "center"
                }}>
                  {this.state.data.reduce((acc, item) => acc + Number(item.Conteo || 0), 0)} Unidades
                </div>
                <button
                  type="button"
                  onClick={() => {
                    const codes = this.state.data.map((i) => i.Codigo).filter(Boolean);
                    this.setState({ stockSAPMap: {} }, () => {
                      this.fetchStockForItems(codes);
                      Swal.fire({
                        title: "Stock SAP actualizado",
                        text: `Se actualizó el stock de ${codes.length} código(s) correctamente.`,
                        icon: "success",
                        confirmButtonText: "OK"
                      });
                    });
                  }}
                  style={{
                    background: "#e3f2fd",
                    border: "1px solid #90caf9",
                    borderRadius: "8px",
                    padding: isMobile ? "8px 4px" : "10px 16px",
                    fontWeight: "bold",
                    cursor: "pointer",
                    fontSize: isMobile ? "13px" : "13px",
                    minHeight: isMobile ? "40px" : "auto",
                    width: "100%"
                  }}
                  title="Actualizar Stock SAP"
                >
                  🔄 Stock SAP
                </button>
              </div>

              <div style={{ display: "flex", gap: isMobile ? "8px" : "10px", flexWrap: "wrap", marginBottom: "8px", alignItems: "center" }}>
                <span style={{ fontSize: isMobile ? "13px" : "12px", color: "#555", fontWeight: "bold", width: isMobile ? "100%" : "auto" }}>Referencias:</span>
                {[
                  { color: "#c8f7c5", border: "#82c97e", label: "Conteo = Stock SAP" },
                  { color: "#f8d7da", border: "#e08a8e", label: "Conteo ≠ Stock SAP" },
                  { color: "#e0e0e0", border: "#aaa", label: "Sin datos / sin existencia en SAP" },
                ].map(({ color, border, label }) => (
                  <div key={label} style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                    <div style={{ width: isMobile ? "18px" : "16px", height: isMobile ? "18px" : "16px", borderRadius: "4px", background: color, border: `1.5px solid ${border}`, flexShrink: 0 }} />
                    <span style={{ fontSize: isMobile ? "13px" : "12px", color: "#444" }}>{label}</span>
                  </div>
                ))}
              </div>

              <div style={{ width: "100%", borderRadius: "8px", overflow: "hidden" }}>
                <JqxGrid
                  ref={gridRef}
                  width={"100%"}
                  height={isMobile ? 450 : 400}
                  source={dataAdapter}
                  columns={columns}
                  altrows={true}
                  columnsresize={true}
                  filterable={true}
                  showfilterrow={true}
                  sortable={true}
                  sortcolumn={"createdAt"}
                  sortdirection={"desc"}
                  theme={"bootstrap"}
                  localization={this.localization}
                />
              </div>

              <br />

              {isMobile ? (
                /* ── Handheld: grid 2 columnas ── */
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px", marginTop: "16px" }}>
                  <Button
                    bsStyle="info"
                    style={{ padding: "10px 6px", fontSize: "13px", fontWeight: "bold", borderRadius: "8px", width: "100%" }}
                    onClick={() => this.setState({ showUbicacionModal: true })}
                  >
                    📍 Por Ubicación
                  </Button>

                  <Button
                    bsStyle="info"
                    style={{ padding: "10px 6px", fontSize: "13px", fontWeight: "bold", borderRadius: "8px", width: "100%" }}
                    onClick={() => this.setState({ showListaModal: true, listaFiltroTexto: "", listaFiltroFechaDesde: "", listaFiltroFechaHasta: "" })}
                  >
                    📋 Inventarios
                  </Button>

                  <Button
                    bsStyle="primary"
                    style={{ padding: "10px 6px", fontSize: "13px", fontWeight: "bold", borderRadius: "8px", width: "100%" }}
                    onClick={this.nuevoInventario}
                  >
                    ➕ Nuevo
                  </Button>

                  <Button
                    bsStyle="warning"
                    style={{ padding: "10px 6px", fontSize: "13px", fontWeight: "bold", borderRadius: "8px", width: "100%" }}
                    onClick={this.guardarComoBorrador}
                    disabled={this.state.finalizado}
                  >
                    💾 Guardar
                  </Button>

                  <Button
                    bsStyle="success"
                    style={{
                      gridColumn: "1 / -1",
                      padding: "14px 6px",
                      fontSize: "15px",
                      fontWeight: "bold",
                      borderRadius: "8px",
                      width: "100%",
                      letterSpacing: "0.3px"
                    }}
                    onClick={this.guardarInventario}
                    disabled={this.state.finalizado}
                  >
                    ✅ Finalizar Conteo
                  </Button>
                </div>
              ) : (
                /* ── Desktop: fila horizontal ── */
                <div style={{ display: "flex", gap: "14px", justifyContent: "center", marginTop: "20px", flexWrap: "wrap" }}>
                  <Button
                    bsStyle="info"
                    style={{ minWidth: "160px", padding: "12px 20px", fontSize: "16px", fontWeight: "bold", borderRadius: "6px" }}
                    onClick={() => this.setState({ showUbicacionModal: true })}
                  >
                    📍 Contabilizar por Ubicación
                  </Button>

                  <Button
                    bsStyle="info"
                    style={{ minWidth: "160px", padding: "12px 20px", fontSize: "16px", fontWeight: "bold", borderRadius: "6px" }}
                    onClick={() => this.setState({ showListaModal: true, listaFiltroTexto: "", listaFiltroFechaDesde: "", listaFiltroFechaHasta: "" })}
                  >
                    📋 Lista Inventarios
                  </Button>

                  <Button
                    bsStyle="primary"
                    style={{ minWidth: "160px", padding: "12px 20px", fontSize: "16px", fontWeight: "bold", borderRadius: "6px" }}
                    onClick={this.nuevoInventario}
                  >
                    ➕ Nuevo Inventario
                  </Button>

                  <Button
                    bsStyle="warning"
                    style={{ minWidth: "160px", padding: "12px 20px", fontSize: "16px", fontWeight: "bold", borderRadius: "6px" }}
                    onClick={this.guardarComoBorrador}
                    disabled={this.state.finalizado}
                  >
                    💾 Guardar
                  </Button>

                  <Button
                    bsStyle="success"
                    style={{ minWidth: "160px", padding: "12px 20px", fontSize: "16px", fontWeight: "bold", borderRadius: "6px" }}
                    onClick={this.guardarInventario}
                    disabled={this.state.finalizado}
                  >
                    ✅ Finalizar Conteo
                  </Button>
                </div>
              )}

              {this.state.isLoading && <Loading />}

              <Modal show={this.state.showListaModal} onHide={() => this.setState({ showListaModal: false })} bsSize="large">
                <Modal.Header closeButton>
                  <Modal.Title>Inventarios Guardados</Modal.Title>
                </Modal.Header>

                {/* ── Barra de filtros ─ */}
                {(() => {
                  const hayFiltros = listaFiltroTexto || listaFiltroFechaDesde || listaFiltroFechaHasta;
                  return (
                    <div style={{ padding: isMobile ? "10px 12px" : "12px 16px", borderBottom: "1px solid #e5e5e5", background: "#f8f9fa" }}>
                      <div style={{
                        display: "grid",
                        gridTemplateColumns: isMobile ? "1fr" : "1fr auto auto auto",
                        gap: isMobile ? "8px" : "10px",
                        alignItems: "center"
                      }}>
                        <input
                          type="text"
                          placeholder="Buscar en comentarios..."
                          value={listaFiltroTexto}
                          onChange={(e) => this.setState({ listaFiltroTexto: e.target.value })}
                          style={{
                            border: "1px solid #ced4da",
                            borderRadius: 6,
                            padding: isMobile ? "8px 10px" : "6px 10px",
                            fontSize: isMobile ? 14 : 13,
                            outline: "none",
                            width: "100%",
                            boxSizing: "border-box"
                          }}
                        />
                        <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                          <span style={{ fontSize: 12, color: "#666", whiteSpace: "nowrap" }}>Desde</span>
                          <input
                            type="date"
                            value={listaFiltroFechaDesde}
                            onChange={(e) => this.setState({ listaFiltroFechaDesde: e.target.value })}
                            style={{
                              border: "1px solid #ced4da",
                              borderRadius: 6,
                              padding: isMobile ? "7px 8px" : "5px 8px",
                              fontSize: isMobile ? 14 : 13,
                              outline: "none"
                            }}
                          />
                        </div>
                        <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                          <span style={{ fontSize: 12, color: "#666", whiteSpace: "nowrap" }}>Hasta</span>
                          <input
                            type="date"
                            value={listaFiltroFechaHasta}
                            onChange={(e) => this.setState({ listaFiltroFechaHasta: e.target.value })}
                            style={{
                              border: "1px solid #ced4da",
                              borderRadius: 6,
                              padding: isMobile ? "7px 8px" : "5px 8px",
                              fontSize: isMobile ? 14 : 13,
                              outline: "none"
                            }}
                          />
                        </div>
                        {hayFiltros && (
                          <Button
                            bsStyle="default"
                            bsSize="small"
                            onClick={() => this.setState({ listaFiltroTexto: "", listaFiltroFechaDesde: "", listaFiltroFechaHasta: "" })}
                            style={{ whiteSpace: "nowrap", fontSize: 12 }}
                          >
                            ✕ Limpiar
                          </Button>
                        )}
                      </div>
                    </div>
                  );
                })()}

                <Modal.Body style={{ maxHeight: "460px", overflowY: "auto" }}>
                  {(() => {
                    const filtered = inventariosGuardados
                      .filter((inv) => {
                        if (listaFiltroTexto) {
                          const txt = listaFiltroTexto.toLowerCase();
                          if (!(inv.Comentario || "").toLowerCase().includes(txt)) return false;
                        }
                        if (listaFiltroFechaDesde) {
                          const fechaInv = moment(inv.fechaDocumento, "YYYYMMDD");
                          if (fechaInv.isBefore(moment(listaFiltroFechaDesde, "YYYY-MM-DD"), "day")) return false;
                        }
                        if (listaFiltroFechaHasta) {
                          const fechaInv = moment(inv.fechaDocumento, "YYYYMMDD");
                          if (fechaInv.isAfter(moment(listaFiltroFechaHasta, "YYYY-MM-DD"), "day")) return false;
                        }
                        return true;
                      })
                      .sort((a, b) => b.IdDocInventario - a.IdDocInventario);

                    if (inventariosGuardados.length === 0) {
                      return <div style={{ color: "#888", textAlign: "center", padding: "20px 0" }}>No hay inventarios guardados.</div>;
                    }
                    if (filtered.length === 0) {
                      return <div style={{ color: "#888", textAlign: "center", padding: "20px 0" }}>Sin resultados para el filtro aplicado.</div>;
                    }

                    return (
                      <>
                        <div style={{ fontSize: 12, color: "#888", marginBottom: 10 }}>
                          {filtered.length} de {inventariosGuardados.length} inventario{inventariosGuardados.length !== 1 ? "s" : ""}
                        </div>
                        {filtered.map((inv) => {
                      const estadoTexto = inv.Estado === "C" ? "CERRADO" : "BORRADOR";
                      const estadoBg = inv.Estado === "C" ? "#d4edda" : "#fff3cd";
                      const estadoColor = inv.Estado === "C" ? "#155724" : "#856404";

                      const fechaDoc = moment(inv.fechaDocumento, "YYYYMMDD");
                      const fechaAct = inv.fechaActualizacion ? moment(inv.fechaActualizacion, "YYYYMMDD") : null;

                      return isMobile ? (
                        /* ── Handheld: tarjeta compacta ── */
                        <div
                          key={inv.IdDocInventario}
                          style={{
                            border: "1px solid #e5e5e5",
                            borderRadius: 10,
                            padding: "12px 14px",
                            marginBottom: 10,
                            backgroundColor: "#fff"
                          }}
                        >
                          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 6 }}>
                            <span style={{ fontSize: 16, fontWeight: "bold", color: "#333" }}>
                              #{inv.IdDocInventario}
                            </span>
                            <span style={{
                              backgroundColor: estadoBg,
                              color: estadoColor,
                              fontWeight: "bold",
                              padding: "3px 12px",
                              borderRadius: 20,
                              fontSize: 11
                            }}>
                              {estadoTexto}
                            </span>
                          </div>

                          <div style={{ fontSize: 12, color: "#666", marginBottom: 4 }}>
                            📅 {fechaDoc.format("DD/MM/YY")}
                            {fechaAct && <span style={{ marginLeft: 10 }}>🔄 {fechaAct.format("DD/MM/YY")}</span>}
                          </div>

                          <div style={{ fontSize: 12, color: "#555", marginBottom: 10, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                            {inv.Comentario || <span style={{ color: "#aaa", fontStyle: "italic" }}>Sin comentario</span>}
                          </div>

                          <Button
                            bsStyle="primary"
                            style={{ width: "100%", fontWeight: "bold", borderRadius: 8 }}
                            onClick={() => {
                              this.abrirInventario(inv);
                              this.setState({ showListaModal: false });
                            }}
                          >
                            Abrir
                          </Button>
                        </div>
                      ) : (
                        /* ── Desktop: layout original ── */
                        <div
                          key={inv.IdDocInventario}
                          style={{
                            border: "1px solid #e5e5e5",
                            borderRadius: 8,
                            padding: "14px 18px",
                            marginBottom: 12,
                            backgroundColor: "#fff",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            gap: 20
                          }}
                        >
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <div style={{ fontSize: 14, marginBottom: 6 }}>
                              <strong>Doc:</strong> {inv.IdDocInventario}
                              {" | "}
                              <strong>Fecha:</strong> {fechaDoc.format("YYYY-MM-DD")}
                              {" | "}
                              <strong>Actualizado:</strong>{" "}
                              {fechaAct ? fechaAct.format("YYYY-MM-DD") : "—"}
                            </div>
                            <div
                              style={{ fontSize: 13, color: "#555", display: "-webkit-box", WebkitLineClamp: 6, WebkitBoxOrient: "vertical", overflow: "hidden", lineHeight: "1.4em", maxHeight: "8.4em" }}
                              title={inv.Comentario || "Sin comentario"}
                            >
                              <strong>Comentario:</strong> {inv.Comentario || "Sin comentario"}
                            </div>
                          </div>

                          <div style={{ display: "flex", alignItems: "center", gap: 12, flexShrink: 0 }}>
                            <div style={{ backgroundColor: estadoBg, color: estadoColor, fontWeight: "bold", padding: "6px 14px", borderRadius: 20, fontSize: 12, minWidth: 100, textAlign: "center" }}>
                              {estadoTexto}
                            </div>
                            <Button
                              bsStyle="primary"
                              style={{ minWidth: 90, fontWeight: "bold" }}
                              onClick={() => {
                                this.abrirInventario(inv);
                                this.setState({ showListaModal: false });
                              }}
                            >
                              Abrir
                            </Button>
                          </div>
                        </div>
                      );
                        })}
                      </>
                    );
                  })()}
                </Modal.Body>

                <Modal.Footer>
                  <Button bsStyle="default" onClick={() => this.setState({ showListaModal: false })}>
                    Cerrar
                  </Button>
                </Modal.Footer>
              </Modal>

              <Modal
                show={this.state.showUbicacionModal}
                onHide={() => this.setState({ showUbicacionModal: false })}
                bsSize="large"
                enforceFocus={false}
              >
                <Modal.Header closeButton>
                  <Modal.Title>Contabilizar por Ubicación</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                  <Row>
                    <Col md={4}>
                      {this.renderInputContainer(
                        <>
                          <input
                            ref={ubicacionEstanteRef}
                            className="form-control"
                            placeholder="Estante"
                            value={this.state.ubicacionEstante}
                            onChange={(e) => this.setState({ ubicacionEstante: e.target.value })}
                            readOnly={!this.isInputEditable("ubicacionEstante")}
                            onBlur={this.disableMobileKeyboard}
                            onTouchStart={(e) => {
                              if (this.state.isMobile && !this.isInputEditable("ubicacionEstante")) {
                                e.preventDefault();
                              }
                            }}
                          />
                          {this.renderKeyboardButton("ubicacionEstante", ubicacionEstanteRef)}
                        </>
                      )}
                    </Col>

                    <Col md={4}>
                      {this.renderInputContainer(
                        <>
                          <input
                            ref={ubicacionSeccionRef}
                            className="form-control"
                            placeholder="Sección"
                            value={this.state.ubicacionSeccion}
                            onChange={(e) => this.setState({ ubicacionSeccion: e.target.value })}
                            readOnly={!this.isInputEditable("ubicacionSeccion")}
                            onBlur={this.disableMobileKeyboard}
                            onTouchStart={(e) => {
                              if (this.state.isMobile && !this.isInputEditable("ubicacionSeccion")) {
                                e.preventDefault();
                              }
                            }}
                          />
                          {this.renderKeyboardButton("ubicacionSeccion", ubicacionSeccionRef)}
                        </>
                      )}
                    </Col>

                    <Col md={4}>
                      {this.renderInputContainer(
                        <>
                          <input
                            ref={ubicacionNivelRef}
                            className="form-control"
                            placeholder="Nivel"
                            value={this.state.ubicacionNivel}
                            onChange={(e) => this.setState({ ubicacionNivel: e.target.value })}
                            readOnly={!this.isInputEditable("ubicacionNivel")}
                            onBlur={this.disableMobileKeyboard}
                            onTouchStart={(e) => {
                              if (this.state.isMobile && !this.isInputEditable("ubicacionNivel")) {
                                e.preventDefault();
                              }
                            }}
                          />
                          {this.renderKeyboardButton("ubicacionNivel", ubicacionNivelRef)}
                        </>
                      )}
                    </Col>
                  </Row>

                  <br />

                  <Button bsStyle="primary" onClick={this.buscarPorUbicacion}>
                    Buscar
                  </Button>

                  <br />
                  <br />

                  {this.renderInputContainer(
                    <>
                      <input
                        ref={barcodeUbicacionRef}
                        className="form-control"
                        placeholder="Escanear TAG..."
                        value={this.state.barcodeUbicacion}
                        onChange={(e) => this.setState({ barcodeUbicacion: e.target.value })}
                        onKeyDown={this.handleBarcodeUbicacionKeyPress}
                        inputMode={this.state.isMobile && !this.isInputEditable("barcodeUbicacion") ? "none" : "text"}
                        autoComplete="off"
                        autoCorrect="off"
                        spellCheck={false}
                        onBlur={this.disableMobileKeyboard}
                        onTouchStart={(e) => {
                          if (this.state.isMobile && !this.isInputEditable("barcodeUbicacion")) {
                            e.preventDefault();
                            this.focusScanInputWithoutKeyboard(barcodeUbicacionRef);
                          }
                        }}
                      />
                      {this.renderKeyboardButton("barcodeUbicacion", barcodeUbicacionRef)}
                    </>
                  )}

                  <br />

                  <div style={{ marginBottom: 10 }}>
                    {this.renderInputContainer(
                      <>
                        <input
                          ref={itemCodeUbicacionSearchRef}
                          className="form-control"
                          placeholder="Buscar por ItemCode dentro de ubicación..."
                          value={this.state.itemCodeUbicacionSearch}
                          onChange={this.buscarCodigoUbicacionManual}
                          readOnly={!this.isInputEditable("itemCodeUbicacionSearch")}
                          onBlur={this.disableMobileKeyboard}
                          onTouchStart={(e) => {
                            if (this.state.isMobile && !this.isInputEditable("itemCodeUbicacionSearch")) {
                              e.preventDefault();
                            }
                          }}
                        />
                        {this.renderKeyboardButton("itemCodeUbicacionSearch", itemCodeUbicacionSearchRef)}
                      </>
                    )}
                  </div>

                  {this.state.resultadosCodigoUbicacion.length > 0 && (
                    <div
                      style={{
                        border: "1px solid #ddd",
                        borderRadius: "6px",
                        marginTop: "5px",
                        marginBottom: "12px",
                        maxHeight: "200px",
                        overflowY: "auto",
                        background: "#fff"
                      }}
                    >
                      {this.state.resultadosCodigoUbicacion.map((item, i) => (
                        <div
                          key={i}
                          style={{ padding: "8px", borderBottom: "1px solid #eee", cursor: "pointer" }}
                          onClick={() => this.seleccionarCodigoUbicacion(item.number_tag)}
                        >
                          <b>{item.ItemCode}</b>
                          &nbsp;| TAG: {item.number_tag}
                          <br />
                          <small>
                            Estante: {item.Estante || "-"} | Sección: {item.Seccion || "-"} | Nivel: {item.Nivel || "-"}
                          </small>
                        </div>
                      ))}
                    </div>
                  )}

                  {!!this.state.itemCodeUbicacionSearch && this.state.resultadosCodigoUbicacion.length === 0 && (
                    <div style={{ marginBottom: 12 }}>
                      <Alert bsStyle="warning" style={{ marginBottom: 8 }}>
                        No existe un tag para el ItemCode ingresado.
                      </Alert>
                      <Button bsStyle="success" onClick={() => this.openCreateTagModal(this.state.itemCodeUbicacionSearch, "ubicacion")}>
                        Crear tag para {this.state.itemCodeUbicacionSearch}
                      </Button>
                    </div>
                  )}

                  <div style={{ fontWeight: "bold", marginBottom: "10px" }}>
                    Escaneados: {this.state.ubicacionData.filter((x) => x.Conteo > 0).length} / {this.state.ubicacionData.length}
                  </div>

                  <JqxGrid
                    ref={gridUbicacionRef}
                    width={"100%"}
                    height={450}
                    source={new jqx.dataAdapter(ubicacionSource)}
                    columns={[
                      {
                        text: "Editar",
                        datafield: "EditarUbicacion",
                        columntype: "button",
                        width: 60,
                        cellsrenderer: () => "✏️",
                        buttonclick: (row) => {
                          const realIndex = this.getRealIndexFromUbicacionGridRow(row);
                          this.handleEditUbicacionRow(realIndex);
                        }
                      },
                      {
                        text: "Eliminar",
                        datafield: "EliminarUbicacion",
                        columntype: "button",
                        width: 70,
                        cellsrenderer: () => "🗑️",
                        buttonclick: (row) => {
                          const realIndex = this.getRealIndexFromUbicacionGridRow(row);
                          this.handleDeleteUbicacionRow(realIndex);
                        }
                      },
                      { text: "Código", datafield: "Codigo", width: 120 },
                      { text: "Conteo", datafield: "Conteo", width: 80, cellsformat: "f2" },
                      { text: "Descripción", datafield: "Descripcion" },
                      { text: "Tag", datafield: "number_tag", width: 120 }
                    ]}
                    altrows={true}
                    columnsresize={true}
                    theme={"bootstrap"}
                    localization={this.localization}
                  />
                </Modal.Body>

                <Modal.Footer>
                  <Button bsStyle="success" onClick={this.agregarUbicacionAlInventario}>
                    Agregar al Inventario
                  </Button>

                  <Button
                    onClick={() =>
                      this.setState({
                        ubicacionData: [],
                        ubicacionDataMap: {},
                        barcodeUbicacion: "",
                        itemCodeUbicacionSearch: "",
                        resultadosCodigoUbicacion: [],
                        ubicacionEstante: "",
                        ubicacionSeccion: "",
                        ubicacionNivel: ""
                      })
                    }
                  >
                    Limpiar
                  </Button>

                  <Button onClick={() => this.setState({ showUbicacionModal: false })}>Cerrar</Button>
                </Modal.Footer>
              </Modal>

              {this.renderCreateTagModal()}
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default Inventario;
